module.exports = __webpack_public_path__ + "img/1f9a2.6d4caef.svg";